export default {"src":"/_next/static/media/sports_tennis.745ef351.svg","height":48,"width":44,"blurWidth":0,"blurHeight":0};